import { useDispatch, useSelector } from "react-redux";
import { IReturnMapDataSources } from "../model/dataSources";
import { ReturnMapSettings, ReturnsMapStore } from "../model/redux-model";
import {SET_SETTING_COLOR, SET_SETTING_CURRENCY, SET_SETTING_GROUP_LEVEL1, SET_SETTING_GROUP_LEVEL2, SET_SETTING_SIZE, SET_SETTING_TRADE_STATUS} from "../model/redux-actions";
import { SelectComponent, FieldComponent, FieldContainerComponent } from "shared/ui-kit";
import { UserClaims } from "shared/mechanics/auth";
import { checkUserClaims } from "shared/auth";

export const SettingsComponent = () => {
	const dispatch = useDispatch();
	const settings = useSelector<ReturnsMapStore, ReturnMapSettings>(x => x.settings);
	const dataSources = useSelector<ReturnsMapStore, IReturnMapDataSources>(x => x.dataSources);

	return (
		<FieldContainerComponent className="default-settings-paddings">
			<FieldComponent title="Валюта">
				<SelectComponent
					items={dataSources.currencies.items}
					selectedKey={settings.currency}
					onSelectedItemChanged={item => {
						checkUserClaims(UserClaims.ALLOW_CURRENCY_DATA, 'Валютные метрики в подписке', () => {
							dispatch(SET_SETTING_CURRENCY(item.key))
						});
					}} />
			</FieldComponent>
			<FieldComponent title="Цвет">
				<SelectComponent
					items={dataSources.colors.items}
					selectedKey={settings.color}
					onSelectedItemChanged={item => dispatch(SET_SETTING_COLOR(item.key))} />
			</FieldComponent>
			<FieldComponent title="Размер блока">
				<SelectComponent
					items={dataSources.sizes.items}
					selectedKey={settings.size}
					onSelectedItemChanged={item => dispatch(SET_SETTING_SIZE(item.key))} />
			</FieldComponent>
			<FieldComponent title="Уровень группировки 1">
				<SelectComponent
					items={dataSources.groups.items.filter(x => x.key != settings.groupLevel2)}
					selectedKey={settings.groupLevel1}
					onSelectedItemChanged={item => dispatch(SET_SETTING_GROUP_LEVEL1(item.key))} />
			</FieldComponent>
			<FieldComponent title="Уровень группировки 2">
				<SelectComponent
					items={dataSources.groups.items.filter(x => x.key != settings.groupLevel1)}
					selectedKey={settings.groupLevel1}
					onSelectedItemChanged={item => dispatch(SET_SETTING_GROUP_LEVEL2(item.key))} />
			</FieldComponent>
			<FieldComponent title="Торговый статус фонда">
				<SelectComponent
					items={dataSources.tradeStatuses.items}
					selectedKey={settings.tradeStatus}
					onSelectedItemChanged={item => dispatch(SET_SETTING_TRADE_STATUS(item.key))} />
			</FieldComponent>
		</FieldContainerComponent>
	)
};